// Import Swiper and modules
import Swiper, {
  Navigation,
  Pagination,
  FreeMode,
  Scrollbar,
  Autoplay,
} from 'swiper';

export class BoltSlideshow {
  constructor(el) {
    if (!el) return;
    this.el = el;
    this.init();
  }

  init() {
    this.freeScroll = this.el.hasAttribute('data-bolt-free-scroll');
    this.autoplay = this.el.hasAttribute('data-bolt-autoplay');
    this.numberOfSlides = this.el.querySelectorAll('.swiper-slide').length;
    this.breakpoint = 1000; // bolt large breakpoint
    this.animationSettings = {};

    this.configureSlidesPerView();
    this.configureSlidesPerGroup();
    this.configureSpaceBetween();
    this.handleMediaQuery();
    this.handleAnimationSettings();

    const slideshow = new Swiper(this.el.querySelector('.swiper'), {
      modules: [Navigation, Pagination, FreeMode, Scrollbar, Autoplay],
      ...this.animationSettings,
      navigation: {
        nextEl: this.el.querySelector(
          '.js-bolt-slideshow__navigation-next-btn',
        ),
        prevEl: this.el.querySelector(
          '.js-bolt-slideshow__navigation-prev-btn',
        ),
      },
      pagination: {
        el: this.el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      scrollbar: {
        el: this.el.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      freeMode: this.freeScroll,
      // only show more slides after breakpoint
      breakpoints: {
        [this.breakpoint]: {
          slidesPerView: this.slidesPerView,
          slidesPerGroup: this.slidesPerGroup,
          spaceBetween: this.spaceBetween,
        },
      },
    });

    slideshow.on('touchEnd', function () {
      // if there is an open popover within the slideshow, hide it after the touch action ends
      let popovers = this.el.querySelectorAll('bolt-popover');
      if (popovers) {
        popovers.forEach((popover) => {
          if (popover.__trigger._tippy.state.isVisible) {
            popover.__trigger._tippy.hide();
          }
        });
      }
    });
  }

  configureSlidesPerView() {
    const slidesPerView = this.el.getAttribute('data-bolt-slides-per-view');
    this.slidesPerView = slidesPerView ? parseInt(slidesPerView, 10) : 1;
  }

  configureSlidesPerGroup() {
    const slidesPerGroup = this.el.getAttribute('data-bolt-slides-per-group');
    this.slidesPerGroup =
      slidesPerGroup === 'auto' || !slidesPerGroup
        ? this.slidesPerView
        : parseInt(slidesPerGroup, 10);
  }

  configureSpaceBetween() {
    switch (this.el.getAttribute('data-bolt-space-between')) {
      case 'large':
        this.spaceBetween = 48; //bolt large spacing
        break;
      case 'small':
        this.spaceBetween = 12; //bolt small spacing
        break;
      case 'none':
        this.spaceBetween = 0;
        break;
      case 'medium': //bolt medium spacing
      default:
        this.spaceBetween = 24;
        break;
    }
  }

  setupNavigation() {
    this.el
      .querySelectorAll('.js-bolt-slideshow__navigation-btn')
      .forEach((element) => {
        element.classList.remove('c-bolt-slideshow__navigation--hidden');
      });
  }

  handleMediaQuery() {
    if (window.matchMedia(`(min-width: ${this.breakpoint}px)`).matches) {
      if (this.numberOfSlides > this.slidesPerView) {
        this.setupNavigation();
      }
    } else {
      if (this.numberOfSlides > 1) {
        this.setupNavigation();
      }
    }
  }

  handleAnimationSettings() {
    // this exists for users who prefer reduced motion.
    // Grab a reference to the media query.
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    // if the user asked for no anmiations:
    if (!mediaQuery || mediaQuery.matches) {
      this.animationSettings.effect = 'fade';
      this.animationSettings.speed = 0;
      this.animationSettings.autoplay = false;
    } else {
      this.animationSettings.effect = 'slide';
      this.animationSettings.speed = 500; // .a-bolt-duration-long
      this.animationSettings.autoplay = this.autoplay ? { delay: 5000 } : false;
    }
  }
}
